var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabProductSaleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0133333 7.83337C3.88 5.82004 7.74667 3.83337 11.6133 1.83337C13.04 2.88671 14.4667 3.95337 15.8933 5.02004C17.3867 3.95337 18.8667 2.90004 20.3333 1.83337C24.2267 3.84671 28.1067 5.88671 32 7.91337C30.6667 9.14004 29.3467 10.38 28.0133 11.6067C29.3333 13.14 30.68 14.6734 32 16.2067C28.3867 18.1934 24.7867 20.2067 21.1733 22.1934L21.1067 22.18C19.6267 20.62 18.1467 19.06 16.68 17.5C19.9733 15.7534 23.2533 13.9934 26.5467 12.2334C23.0533 10.2467 19.52 8.35337 16.0133 6.39337C12.48 8.32671 8.96 10.26 5.44 12.2067C8.74667 13.9667 12.0533 15.7134 15.3467 17.4734C13.88 19.0867 12.4 20.7134 10.9333 22.3267C7.29333 20.22 3.64 18.1134 0 16.0067V15.8467L0.04 15.98C1.33333 14.5 2.68 13.0734 4 11.6067C2.66667 10.3534 1.33333 9.10004 0 7.83337V7.70004L0.0133333 7.83337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 19.4333C18.08 20.9133 19.48 22.4067 20.8934 23.8867C23.2534 22.5667 25.6267 21.26 28 19.94C28 21.6734 28.0134 23.4067 27.9867 25.14C24.2134 27.1267 20.44 29.1667 16.6667 31.1667C16.68 27.26 16.6534 23.34 16.68 19.4333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 24.0067C12.5734 22.5133 13.9334 20.98 15.3334 19.5C15.3467 23.38 15.3334 27.26 15.3467 31.14C11.5467 29.18 7.80002 27.1133 4.01336 25.1267C4.00002 23.3667 4.00002 21.6067 4.01336 19.8467C6.40002 21.2467 8.80002 22.62 11.2 24.0067Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabProductSaleActive);
export default __webpack_public_path__ + "static/media/tab-product-sale-active.70242f6aa3a8ff1d8edd4a2a112230e2.svg";
export { ForwardRef as ReactComponent };